import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import avTalkdownTutorialGif from '@/images/av-talkdown-tutorial.gif';

interface AlphaTalkdownDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cameraName?: string;
}

const AlphaTalkdownDialog: React.FC<AlphaTalkdownDialogProps> = ({
  open,
  onOpenChange,
  cameraName
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/75" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 flex w-full max-w-2xl -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-6 rounded-md bg-slate-700 p-8 text-white shadow">
          <Dialog.Title className="text-2xl font-bold text-blue-400">
            Alpha Camera Talkdown Instructions
          </Dialog.Title>
          
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="text-lg text-white">
              For Alpha cameras, talkdown must be performed within the Alphavision Player.
            </div>
            
            <div className="text-sm text-gray-300">
              Camera: <span className="font-semibold text-blue-300">{cameraName || 'Selected Camera'}</span>
            </div>
            
            <div className="w-full max-w-md">
              <img 
                src={typeof avTalkdownTutorialGif === 'string' ? avTalkdownTutorialGif : avTalkdownTutorialGif.src}
                alt="Alpha Camera Talkdown Demo"
                className="w-full h-auto rounded-lg border-2 border-blue-400"
              />
            </div>
            
            <div className="text-sm text-gray-300 space-y-2">
              <p>• Navigate to the queue area to perform talkdown</p>
              <p>• Use the Alphavision Player controls for audio</p>
              <p>• This integration requires special handling</p>
            </div>
          </div>
          
          <div className="flex gap-4 mt-4">
            <Dialog.Close asChild>
              <button className="rounded-md bg-blue-500 px-6 py-2 text-white hover:bg-blue-600 transition-colors">
                Understood
              </button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default AlphaTalkdownDialog;
